import { isFeatureEnabled } from '../config/feature-flags';

const ALL_OPTIONS = [
  { label: 'Billions', value: 'Billions' },
  { label: 'Millions', value: 'Millions' },
  { label: 'Thousands', value: 'Thousands' },
] as const;

const OPTIONS_WITHOUT_BILLIONS = [
  { label: 'Millions', value: 'Millions' },
  { label: 'Thousands', value: 'Thousands' },
] as const;

// This SCALE_CONFIG condition is added to accepting feature flag for "Billions" Options
// Currently only show "Millions" and "Thousands" in prod
// Order: Billions, Millions, Thousands (Billions first when enabled)
// Default: Always Millions
export const SCALE_CONFIG = {
  DEFAULT: 'Millions',
  get OPTIONS() {
    return isFeatureEnabled('SCALE_BILLIONS')
      ? ALL_OPTIONS
      : OPTIONS_WITHOUT_BILLIONS;
  },
} as const;

export type ScaleValue = (typeof ALL_OPTIONS)[number]['value'];
